import _ from 'underscore';
import typeMapping from '@bingads-webui-component-legacy/form/view/field/type';

// normalize value messages to array, since value could not be nessasary string, object is not generic enough
function normalizeValueMessages(valueMessages, values) {
  if (_.isArray(valueMessages)) {
    return valueMessages;
  } else if (_.isObject(valueMessages)) {
    return _.map(values, (value) => valueMessages[value]);
  } else {
    return valueMessages;
  }
}

export default function generateFieldOptions(schema, fields, prefix, s$i18n) {
  return _.map(fields, (field) => {
    const fieldObject = _.isString(field) ? { property: field } : field;

    if (!_.isEmpty(fieldObject.fields)) {  //has subfields
      const subFields = generateFieldOptions(schema, fieldObject.fields, prefix, s$i18n);
      const property = _.uniqueId(_.pluck(subFields, 'property').join(''));  //if subfields has only one field, the name will be conflicted with property

      return _.extend({}, fieldObject, {
        control: fieldObject.type,
        property,
        id: `${prefix}-${property}`,
        hasSubFields: true,
        fields: subFields,
      });
    }

    const type = schema.name;
    const property = fieldObject.property;
    const propertySchema = schema.properties[fieldObject.property] || {};
    const typeOptions = typeMapping(propertySchema) || {};
    const values = fieldObject.values || typeOptions.values;
    const valueMessages = normalizeValueMessages(fieldObject.valueMessages, values) || _.map(values, _.partial(s$i18n.value, type, property));

    // Common options for all fields
    const commonOptions = {
      showLabel: true,
      schema: propertySchema,
      message: valueMessages[0],
      id: `${prefix}-${property}`,
      label: s$i18n.property(type, property),
      visible: true,
      required: Boolean(propertySchema.required || _.contains(schema.required, property)),
    };

    const normalizedOptions = {
      valueMessages,
    };

    return _.extend(commonOptions, typeOptions, fieldObject, normalizedOptions);
  });
}
